export default __webpack_public_path__ + "static/media/account_box-24px.dba80fd2.svg";